import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMagnifierIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="m15.138 14.195-3.783-3.783a6 6 0 1 0-.943.943l3.783 3.783a.665.665 0 0 0 1.126-.601.67.67 0 0 0-.183-.342m-8.471-2.862a4.667 4.667 0 1 1 0-9.333 4.667 4.667 0 0 1 0 9.333" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgMagnifierIcon;